import styled from "styled-components";

export const StyledModal = styled.div`
  position: fixed;
  inset: 0;
  z-index: 998;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-lg);
`;

export const StyledContent = styled.div<{ $width: number }>`
  background-color: var(--color-white);
  width: 100%;
  max-width: ${({ $width }) => `${$width}px`};
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
`;

export const StyledHeader = styled.div<{
  $bordered: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md);
  background-color: var(--color-background);
  position: relative;
  ${({ $bordered }) => $bordered ? 'border-bottom: 1px solid var(--color-border);' : ''}
`;

export const StyledCloseButton = styled.button`
  background: transparent;
  border: none;
  padding: var(--spacing-xs);
  cursor: pointer;
  display: flex;
  align-items: center;
`;
